
export default "/assets/sparkles-mini.4e423d54.svg"